import React from 'react';
import Card from '../../ui/Card/Card';
import classnames from 'classnames';
import * as styles from './InlineBreaker.module.scss';
import ButtonLink from '../../ui/Buttons/ButtonLink';
import { GatsbyImage } from "gatsby-plugin-image";

type Props = {
    title: string;
    kurzbeschreibung: string;
    to: string;
    buttonText: string;
    icon: {
        src: any
        alt: string;
        ratio: number;
    }
}

export default function InlineBreaker (props: Props) {

    const {to, kurzbeschreibung, buttonText, title, icon} = props;

    return (
        <div className={classnames([styles.fullHeight])}>
            <Card to={to} className={styles.card}>
            <div className={classnames(["columns is-vcentered",  styles.fullHeight])}>
                <div className="column">
                    <h3 className="title has-text-weight-bold" dangerouslySetInnerHTML={{__html: title}}></h3>
                    <p dangerouslySetInnerHTML={{__html: kurzbeschreibung}}>

                    </p>
                    <ButtonLink to={to} variation="minimal">{buttonText}</ButtonLink>
                </div>
                <div className="column is-one-third is-hidden-touch">
                    <GatsbyImage
                        image={{...icon.src.childImageSharp.gatsbyImageData, aspectRatio: icon.ratio}} alt="" />
                </div>
            </div>
            </Card>
        </div>
    );
}